import { CustomersApiRemoteService } from '../../Services/api/customers/customers-service'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyCustomersUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly CustomersApi: CustomersApiRemoteService) {}
    

  public async handle (
    customerId: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CustomersApi.destroy(customerId)

      if (response.isFailure) {
        return response
      }
    
      
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
